import React, { ReactNode } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { ReactComponent as SuccessIcon } from 'assets/icons/success.svg';
import { ROUTE_KEYS } from 'utils/constants';
type SuccessModalProps = {
  show: boolean;
  children?: ReactNode;
  onClose: () => void;
  onAfterOpen?: () => void;
  link?: string;
  linkText?: string;
  onLinkClick?: () => void;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};
export function SuccessModal({
  show,
  children,
  onClose,
  onAfterOpen,
  link = ROUTE_KEYS.OVERVIEW,
  linkText = 'BACK TO HOME',
  onLinkClick
}: SuccessModalProps) {
  return (
    <Modal
      isOpen={show}
      onAfterOpen={onAfterOpen}
      onRequestClose={onClose}
      style={customStyles}
      ariaHideApp={false}>
      <div className='px-12 py-4'>
        <div className='flex justify-center pb-2 '>
          <SuccessIcon className='h-28 w-20' />
        </div>
        <div className='w-64 text-center pb-4 font-semibold leading-6 '>{children}</div>
      </div>
      <div className='flex justify-center bg-[#F8F6F7] text-[#E60A2B] text-xs font-[500] tracking-wider py-5 border-b rounded-[10px] border-transparent'>
        <Link
          onClick={() => {
            onClose(), onLinkClick?.();
          }}
          to={link}>
          <p className='uppercase font-medium'>{linkText}</p>
        </Link>
      </div>
    </Modal>
  );
}
